const loadedImages = new Set()

export const isImageCached = (src) => {
  if (loadedImages.has(src)) {
    return true
  }

  const img = new Image()
  img.src = src
  return img.complete && img.naturalHeight > 0
}

export const loadImage = (src) => {
  if (isImageCached(src)) {
    loadedImages.add(src)
    return Promise.resolve()
  }

  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => {
      loadedImages.add(src)
      resolve()
    }
    img.onerror = () => {
      loadedImages.add(src)
      resolve()
    }
    img.src = src
  })
}

export const wait = (ms) =>
  new Promise((resolve) => {
    window.setTimeout(resolve, ms)
  })
